document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.come-funziona-section');
  if (!section) return;
  
  const steps = section.querySelectorAll('.step-item');
  const images = section.querySelectorAll('.step-image');
  let currentStep = 1;
  
  // Function to update active step based on scroll position within the section
  function updateActiveStep() {
    const sectionRect = section.getBoundingClientRect();
    const sectionTop = sectionRect.top;
    const sectionHeight = sectionRect.height;
    const viewportHeight = window.innerHeight;
    
    // Check if section is visible in viewport
    if (sectionTop > viewportHeight || sectionTop + sectionHeight < 0) {
      return; // Section is not visible
    }
    
    // When the section top hits 120px (sticky position), start counting
    if (sectionTop > 120) {
      // Section hasn't reached sticky position yet, stay on step 1
      if (currentStep !== 1) {
        currentStep = 1;
        updateStepDisplay(1);
      }
      return;
    }
    
    // Calculate scroll progress from when section becomes sticky
    // The section becomes sticky at top: 120px
    // It should scroll through sectionHeight - viewportHeight + 120
    const scrollableDistance = sectionHeight - viewportHeight + 120;
    const scrolledDistance = 120 - sectionTop;
    const scrollProgress = Math.max(0, Math.min(1, scrolledDistance / scrollableDistance));
    
    // Map scroll progress to steps (0-0.25 = step 1, 0.25-0.5 = step 2, etc)
    const totalSteps = steps.length;
    let activeStepIndex = Math.floor(scrollProgress * totalSteps);
    
    // Handle edge case where scrollProgress = 1 exactly
    if (scrollProgress === 1) {
      activeStepIndex = totalSteps - 1;
    }
    
    // Ensure we stay within bounds
    activeStepIndex = Math.max(0, Math.min(totalSteps - 1, activeStepIndex));
    const newStep = activeStepIndex + 1;
    
    // Only update if step changed
    if (newStep !== currentStep) {
      currentStep = newStep;
      updateStepDisplay(newStep);
    }
  }
  
  function updateStepDisplay(stepNumber) {
    // Update step items
    steps.forEach((step, index) => {
      if (index + 1 === stepNumber) {
        step.classList.add('active');
      } else {
        step.classList.remove('active');
      }
    });
    
    // Update images
    images.forEach((img, index) => {
      if (index + 1 === stepNumber) {
        img.classList.add('active');
      } else {
        img.classList.remove('active');
      }
    });
  }
  
  // Use scroll-based approach for all viewports
  window.addEventListener('scroll', updateActiveStep, { passive: true });
  updateActiveStep(); // Initial call
  
  // Initialize first step as active
  if (steps.length > 0) {
    steps[0].classList.add('active');
  }
  if (images.length > 0) {
    images[0].classList.add('active');
  }
});